import React, { useState } from "react";
import { Typography, Paper, TextField, Button, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../services/apiClient";
import SEO from "../../components/SEO";

export default function AdminSecurityPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    currentPassword: "",
    nextLogin: "",
    nextPassword: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const save = async () => {
    setError("");
    setMessage("");
    try {
      await apiClient.request("/api/admin/security", {
        method: "PATCH",
        body: JSON.stringify(form),
      });
      setMessage("Identifiants mis a jour. Reconnexion requise.");
      setTimeout(() => navigate("/admin/login"), 1200);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <SEO title="Admin Securite | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 2 }}>Securite</Typography>
      <Paper sx={{ p: 2, display: "grid", gap: 1, maxWidth: 520 }}>
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          type="password"
          label="Mot de passe actuel"
          value={form.currentPassword}
          onChange={(e) => setForm((s) => ({ ...s, currentPassword: e.target.value }))}
        />
        <TextField
          label="Nouveau login"
          value={form.nextLogin}
          onChange={(e) => setForm((s) => ({ ...s, nextLogin: e.target.value }))}
        />
        <TextField
          type="password"
          label="Nouveau mot de passe"
          value={form.nextPassword}
          onChange={(e) => setForm((s) => ({ ...s, nextPassword: e.target.value }))}
        />
        <TextField
          type="password"
          label="Confirmation mot de passe"
          value={form.confirmPassword}
          onChange={(e) => setForm((s) => ({ ...s, confirmPassword: e.target.value }))}
        />
        <Button variant="contained" onClick={save}>Mettre a jour</Button>
      </Paper>
    </>
  );
}
